import PhoneInputLibrary from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "../../styles/phone-input-default.css";
import "../../../styles/phone-input-onboarding.css";
import "../../../styles/phone-input-rtl.css";
import styles from "./PhoneInput.module.css";

interface PhoneInputProps {
	value: string;
	onChange: (value: string) => void;
	placeholder?: string;
	variant?: "default" | "onboarding";
	error?: boolean;
	className?: string;
	defaultCountry?: string;
}

export function PhoneInput({
	value,
	onChange,
	placeholder,
	variant = "default",
	error = false,
	className = "",
	defaultCountry = "us",
}: PhoneInputProps) {
	const wrapperClass = `phone-input-2-wrapper ${styles.wrapper} ${styles[variant]} ${error ? styles.error : ""} ${className}`;

	return (
		<div className={wrapperClass} dir="ltr">
			<PhoneInputLibrary
				country={defaultCountry}
				value={value}
				onChange={onChange}
				placeholder={placeholder}
				inputProps={{
					required: false,
					autoFocus: false,
				}}
			/>
		</div>
	);
}
